const state = {
  videoUrl: '',
  vimeoApiLoaded: false,
  youtubeApiLoaded: false  
}

export default state
